globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};
appCustomerSpace.Controllers.LocalManagement = appCustomerSpace.Controllers.LocalManagement || {};

appCustomerSpace.Controllers.LocalManagement.OnlineServicesController = (function(superClass) {

    utils.extend(OnlineServicesController, superClass);

    function OnlineServicesController() {
        return OnlineServicesController.__super__.constructor.apply(this, arguments);
    }

    $.extend(OnlineServicesController.prototype, {
        init: function(){
            this.initEvents();

            return OnlineServicesController.__super__.init.apply(this, arguments);
        },
        initEvents: function(){
            var $form = $('form.online-services-form');

            // Open/Close checkbox
            $form.on('change', '.switchery', function(){
                var $checkbox = $(this),
                    $attributeItemWrapper = $checkbox.closest('.attribute-item-wrapper'),
                    $urlContainer = $attributeItemWrapper.find('.url-container');

                if($checkbox.is(':checked')) {
                    $urlContainer.show();
                    $urlContainer.find('input.input-destroy').val(false);
                } else {
                    $urlContainer.hide();
                    $urlContainer.find('input.input-destroy').val(true);
                }
            });

        }
    });

    return OnlineServicesController;

})(appCustomerSpace.Controllers.LocalManagement.MainController);
